var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-status"},[_c('table-pagination',{attrs:{"memory":"tabPaneAccountStatus","tableData":_vm.tableData,"columnData":_vm.columnData,"columnOptionShow":"","paginationHide":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }